import { Text } from '@shared/components';

import type { AppOptions } from '../../types';

interface AppPermissionTitleProps {
  variant: AppOptions;
}

const TITLE_VARIANT_MAP: Record<AppOptions, string> = {
  'exam-management': 'Exam Management',
  'exam-center': 'Exam Center',
  'user-management': 'User Management',
  reports: 'Reports',
};

export default function AppPermissionTitle(props: Readonly<AppPermissionTitleProps>) {
  return <Text variant='h3'>{TITLE_VARIANT_MAP[props.variant]}</Text>;
}
